import { DATE_FORMAT_MASK, MONTHS } from '../const';

export const ACTION_FETCH = 'fetch';
export const STORE_MODULE_NAME = 'activityCalendar';
export const TITLE_DEFAULT = 'Календарь мероприятий';

export { DATE_FORMAT_MASK, MONTHS };


// WEBPACK FOOTER //
// ./src/pages/activities/calendar/const.ts